import { useMemo } from 'react';
import { Flex, Link } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { GetIcon } from '../../../../components/icons';
import type { ProductItemEditor } from '../../../../bff-api/baskets/model';
import type { Registrant } from '../../../checkout/model/Registrant';

export interface GiftRegistryLinkProps {
    productItem: ProductItemEditor;
}

const getRegistrantName = (registrant?: Registrant | null): string =>
    registrant ? `${registrant?.firstName} ${registrant?.lastName}` : '';

export const GiftRegistryLink = ({ productItem }: GiftRegistryLinkProps) => {
    const intl = useIntl();
    const registrants = useMemo(() => {
        const registrantList = [
            getRegistrantName(productItem.c_registrant),
            getRegistrantName(productItem.c_coRegistrant),
        ].filter((registrant) => !!registrant.trim());

        return intl.formatList(registrantList, { type: 'conjunction' });
    }, [intl, productItem]);

    return (
        <Flex width="100%" gap={5}>
            <div className="flex items-center gap-2">
                <div className="bottom-0 right-0 flex h-8 w-8 items-center justify-center rounded-full border border-slt-black-900 bg-white">
                    <GetIcon name="gift" size="sm" />
                </div>
                <Link
                    href={productItem.productListItem?.productList?.c_url}
                    data-testid="cart-item-gift-registry-link"
                    textStyle="body-small"
                    target="_blank"
                    textDecorationLine="underline"
                    color="slt-pepper.1000"
                >
                    <FormattedMessage
                        id="cart.item.gift-registry.name"
                        defaultMessage="From {registrants} Gift Registry"
                        values={{
                            registrants,
                        }}
                    />
                </Link>
            </div>
        </Flex>
    );
};
